import { Component, OnDestroy, OnInit } from "@angular/core";
import { MonitoringAlertsViewModel } from "./monitoring-alerts.view-model";
import { IMonitoringErrorsRepository } from "../../../domain/monitoring/i-monitoring-errors-repository";

@Component({
  selector: "evrideo-alerts",
  templateUrl: "./monitoring-alerts.component.html",
  styleUrls: ["./monitoring-alerts.component.scss"],
})
export class MonitoringAlertsComponent implements OnInit, OnDestroy {
  vm: MonitoringAlertsViewModel;
  constructor(
    private _monitoringErrorsRepository: IMonitoringErrorsRepository,
  ) {}

  async ngOnInit() {
    this.vm = new MonitoringAlertsViewModel(this._monitoringErrorsRepository);
    await this.vm.onInit();
  }

  ngOnDestroy(): void {
    this.vm.onDestroy();
  }
}
